import React from 'react'
import View from '../View'
import LeftSidebarView from '../LeftView'
import { useSelector } from 'react-redux'
import { useBoardContext } from 'dataProviders/Board'
import KanBoIcon from 'components/KanBoIcon'
import ViewHeader from '../ViewHeader'

export const BoardModalViewHeader: React.FC<{
  boardName: string;
  title: React.ReactNode;
}> = ({
  boardName,
  title,
}) => {
  return (
    <ViewHeader
      icon={<KanBoIcon name='kanbo-16-my-board' />}
      header={boardName}
    >
      {title}
    </ViewHeader>  
  )
}

const BoardModalView = React.forwardRef<View, React.ComponentPropsWithRef<typeof LeftSidebarView>>((props, ref) => {
  const { id } = useBoardContext()

  const boardName = useSelector(state => state['view-board'].view[id]?.name)

  return (
    <LeftSidebarView
      {...props}
      ref={ref}
      title={
        <BoardModalViewHeader
          boardName={boardName}
          title={props.title}
        />
      }
    />
  )
})

export default BoardModalView
